var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('el-upload',{staticClass:"upload-demo",attrs:{"multiple":true,"show-file-list":true,"on-remove":_vm.handleRemove,"file-list":_vm.value,"action":"","on-success":_vm.handleSuccess,"before-upload":_vm.beforeUpload,"http-request":_vm.handleFileChange}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }